import { atom, selectorFamily } from "recoil";

const pharmacyBranchesState = atom({
    key: "pharmacyBranchesState", // unique ID (with respect to other atoms/selectors)
    default: [], // default value (aka initial value)
});

// Selector family that takes pharmacyId as parameter and returns isIntegrated status
const isPharmacyIntegratedSelector = selectorFamily({
    key: "isPharmacyIntegratedSelector",
    get: (pharmacyId) => ({ get }) => {
        const pharmacyBranches = get(pharmacyBranchesState);
        const selectedPharmacyBranch = pharmacyBranches.find(
            (pharmacyBranch) => pharmacyBranch.Id === pharmacyId
        );
        return selectedPharmacyBranch?.isIntegrated || false;
    },
});

// Selector family that takes pharmacyId as parameter and returns the full pharmacy branch object
const getPharmacyBranchSelector = selectorFamily({
    key: "getPharmacyBranchSelector",
    get: (pharmacyId) => ({ get }) => {
        const pharmacyBranches = get(pharmacyBranchesState);
        return pharmacyBranches.find(
            (pharmacyBranch) => pharmacyBranch.Id === pharmacyId
        ) || null;
    },
});

export {
    pharmacyBranchesState,
    isPharmacyIntegratedSelector,
    getPharmacyBranchSelector
};
